module.exports = __webpack_public_path__ + "media/female_resultE.f4971df4.mp3";